export enum ReminderFor {
    SUBMISSION = 1,
    APPROVAL = 2
}
